import React from 'react';
import MigrationForm from './components/MigrationForm';
import { createTheme, ThemeProvider, CssBaseline, Box } from '@mui/material';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#90caf9' },
    background: { default: '#0b1220', paper: '#0f1724' },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: { borderRadius: 12 },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Box className="app-shell" sx={{ height: '100vh', width: '100vw', overflow: 'hidden', m: 0, p: 0 }}>
        <MigrationForm setResponse={() => {}} />
      </Box>
    </ThemeProvider>
  );
}

export default App;